// src/lib/rttParser.ts
import type { Element } from "@xmpp/xml"

const RTT_XMLNS = "urn:xmpp:rtt:0"

export type RttEventType = "new" | "append" | "reset"

export type RttEvent = {
  roomJid: string
  event: RttEventType
  seq: number
  text: string
}

export function parseRttStanza(stanza: Element): RttEvent | undefined {
  const rtt = stanza.getChild("rtt", RTT_XMLNS)
  if (!rtt) return undefined

  const from = stanza.getAttr("from") ?? ""
  const roomJid = from.split("/")[0] ?? ""

  const rawEvent = rtt.getAttr("event")
  const event: RttEventType =
    rawEvent === "new" ? "new" : rawEvent === "reset" ? "reset" : "append"

  const seq = parseInt(rtt.getAttr("seq") ?? "0", 10)
  const text = rtt.getChild("t")?.getText() ?? ""

  return { roomJid, event, seq, text }
}
